import React, { Component } from 'react';
import { connect } from 'react-redux';
import Events from './Events';
import Sidebar from './Sidebar';
import Modal from 'react-responsive-modal';
import { MODAL_HIDE } from '../../constants/action-types';
import { Router, Route, IndexRoute } from 'react-router';
import { history } from '../../index'
import EventDetailsComponent from './event/details/event-details';
import Bets from './Bets';
import Oracle from './Oracle';
import Terms from './Terms';
import Auth from '../auth/auth';
import Leaderboard from './Leaderboard';
import Root from './Root';

class AppComponent extends Component {
    constructor(props) {

        super(props);

    }

    render() {

        return (
            <div>
                {this.props.app.startupComplete ? (
                    <main data-show-nav={this.props.nav.showNav} data-nav-minified={this.props.nav.navMinified}>
                        <Sidebar />
                        <div id='content-wrap'>
                            <Router history={history}>
                                <Route path='/' component={Root}>
                                    <IndexRoute component={Events} />
                                    <Route path='/events' component={Events} />
                                    <Route path='/events/:id' component={EventDetailsComponent} />
                                    <Route path='/leaderboard' component={Leaderboard} />
                                    <Route path='/oracle' component={Oracle} />
                                    <Route path='/bets' component={Bets} />
                                    <Route path='/auth' component={Auth} />
                                    <Route path='/terms-of-service' component={Terms} />
                                </Route>
                            </Router>
                        </div>
                    </main>
                ) : null}
            </div>
        );

    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    closeModal: () => dispatch({ type: MODAL_HIDE })

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AppComponent)


// WEBPACK FOOTER //
// ./src/components/general/App.js